import { render } from "./ForEachFormRow.vue?vue&type=template&id=0af53c96"
import script from "./ForEachFormRow.vue?vue&type=script&lang=js"
export * from "./ForEachFormRow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__